module.exports = __webpack_public_path__ + "img/36.94efc295.png";